export default "__VITE_ASSET__chtS7glf__"